const booleanChoices = [
  { id: 1, name: 'ra.boolean.true' },
  { id: 0, name: 'ra.boolean.false' },
];

export default booleanChoices;
